import set from "@rill/set";
import rill from "rill";
import getFlexibleProgram from "../../coaching-portal/flexible-program/flexible-program.controller";
import getFlexibleProgramPreview from "../../coaching-portal/flexible-program/flexible-program-preview.controller";
import getProgramEditor from "./program-editor.controller";
import ProgramOverview from "./program-overview";
import ProgramPreview from "./program-preview";
import getPrograms from "./programs.controller";

const Programs = (app) => {
  app.at(
    "/programs/*",
    rill()
      .use(set("heading", ["Athlete", "Programs"]))
      .setup(ProgramOverview)
      .setup(ProgramPreview)
      .setup((app) => app.get("/", getPrograms))
      .setup((app) => app.get("/edit-program/:cycleId", getProgramEditor))
      // Lives under /athlete-portal so it gets the athlete header and tabs -
      // wrappers/index.js picks the layout by URL prefix, and the coaching
      // portal's has neither. It also keeps "Programs" highlighted, which is
      // where the coach came from.
      .setup((app) => app.get("/flexible-program/:cycleId", getFlexibleProgram))
      .setup((app) =>
        app.get("/flexible-program-preview/:cycleId", getFlexibleProgramPreview)
      )
  );
};

export default Programs;
